import * as React from 'react'

import Rating from 'modules/core/components/Rating'

interface Props {
  value?: number
  onChange?: (newValue: number | null) => void
  readonly?: boolean
}

export const RatingSelector = ({ value, onChange, readonly = false }: Props) => {
  return (
    <Rating
      min={1}
      max={5}
      value={value}
      onClick={(newValue) => {
        onChange?.(newValue === value ? null : newValue)
      }}
      readonly={readonly}
    />
  )
}
